import {
  Avatar,
  Button,
  Card,
  Col,
  Modal,
  Row,
  Select,
  Typography,
  Popconfirm,
} from "antd";
import Search from "antd/es/input/Search";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../../utils/context/UserContext";
import { getOrder,voidOrder } from "../../utils/api/TransactionAPI";
import Meta from "antd/es/card/Meta";
import RetrievedOrderDefaultType from "../../utils/types/RetrievedOrderDefaultType";
import { useNavigate } from "react-router-dom";
import { SALES_ORDER_ROUTE } from "../../utils/router/routes";
import CustomModal from "../../components/Modals/CustomModal";
import ORPrint from "../../components/PDFDocuments/ORPrint";
import { getBranch } from "../../utils/api/BranchesAPI";
import {
  ERROR_NOTIFICATION_TYPE,
  SUCCESS_NOTIFICATION_TYPE,
  getAPIResponseMessage,
} from "../../utils/api/_ConstantsAPI";

import BranchDefaultType from "../../utils/types/BranchDefaultType";
import { GlobalContext } from "../../App";

export default function OrderRetrievalModal({
  isOpen,
  setIsOpen,
  onSelectOrder,
}) {
  const navigate = useNavigate();

  const { openNotification } = useContext(GlobalContext);
  const { profile } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const [modalWidth, setModalWidth] = useState("30vw");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [branchInfo, setBranchInfo] = useState(BranchDefaultType);

  const [searchValue, setSearchValue] = useState("");

  const [localOrderList, setLocalOrderList] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(RetrievedOrderDefaultType);
  const [customerName, setCustomerName] = useState("");

  const [dataSource, setDataSource] = useState([]);

  const [selectedTransType, setSelectedTransType] = useState("");

  const fetchBranchDetails = async () => {
    const res = await getBranch(profile.branchCode);
    if (res.isSuccessful) {
      setBranchInfo(res.data[0]);
    }
  };

  const handleSalesOrderSearch = async (value) => {
    setIsLoading(true);
    const res = await getOrder(value, profile.branchCode, selectedTransType);
    if (res.isSuccessful && res.orderList.length !== 0) {
      setCustomerName(res.customerName);
      setSelectedOrder(res);

      const payload = {
        orderNumber: res.orderNumber,
        cashier: profile.id,
        amountpaid: res.amountpaid,
        productList: res.orderList.map((product) => ({
          productId: product.id,
          totalQty: product.productQty,
          productDisc: 0,
          productPriceperkg: product.productPriceperkg,
          productDesc: product.productDesc,
        })),
      };

      const cashierName = profile.firstName + " " + profile.lastName;

      setDataSource([payload, branchInfo, res.orderNumber, cashierName]);
    } else {
      setSelectedOrder(RetrievedOrderDefaultType);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchBranchDetails();
  }, []);


  const handleVoidOrder = async (orderNumber) => {
    setIsLoading(true);
    const payload = {
      order_number: orderNumber,
      cashier_id: profile.id,
    };
    const res = await voidOrder(payload);

    if (res.isSuccessful) {
      openNotification(
        SUCCESS_NOTIFICATION_TYPE,
        "Sales Order",
        "Order voided successfully!"
      );
      navigate(SALES_ORDER_ROUTE);
      setIsLoading(true);
    } else {
      openNotification(
        ERROR_NOTIFICATION_TYPE,
        "Sales order",
        getAPIResponseMessage(res.data)
      );
      setIsLoading(false);
    }
  };



  return (
    <Modal
      centered
      closable={false}
      maskClosable={false}
      open={isOpen}
      onOk={setIsOpen}
      footer={null}
      confirmLoading={isLoading}
      keyboard={false}
    >
      {selectedTransType === "" && (
        <>
          <Row justify="center" align="middle">
            <Col xs={24} sm={18}>
              <Select
                style={{ width: "100%" }}
                size="large"
                loading={isLoading}
                disabled={isLoading}
                placeholder="Select transaction type"
                onChange={(value) => setSelectedTransType(value)}
              >
                <Select.Option value={"1"}>Retail</Select.Option>
                <Select.Option value={"2"}>Wholesale</Select.Option>
              </Select>
            </Col>
          </Row>
        </>
      )}

      {selectedTransType !== "" && (
        <>
          <Row justify="center" align="middle">
            <Col xs={24} sm={18}>
              <Search
                loading={isLoading}
                enterButton
                size="large"
                placeholder="Please enter order number"
                value={searchValue}
                onSearch={(value) => handleSalesOrderSearch(value)}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchValue(value);
                  handleSalesOrderSearch(value);
                }}
                allowClear={true}
              />
            </Col>
          </Row>
          {/* <Row justify="center" align="middle" className="mb-3">
            <Col xs={24} sm={18} className="text-center">
              <Typography.Text
                type="secondary"
                style={{ cursor: 'pointer' }}
                onClick={() => console.log('Show all pending orders')}
              >
                Show all pending orders?
              </Typography.Text>
            </Col>
          </Row> */}
          {selectedOrder.orderNumber !== "" && (
            <Card
              hoverable
              title={`Order no: ${selectedOrder.orderNumber}`}
              loading={isLoading}
              className="my-3"
              // onClick={() => {
              //   onSelectOrder(selectedOrder, customerName, selectedTransType);
              //   setSelectedOrder(RetrievedOrderDefaultType);
              //   setSearchValue("");
              //   setIsOpen(false);
              // }}
              onClick={
                selectedOrder.entry_type !== 2
                  ? () => {
                      onSelectOrder(
                        selectedOrder,
                        customerName,
                        selectedTransType
                      );
                      setSelectedOrder(RetrievedOrderDefaultType);
                      setSearchValue("");
                      setIsOpen(false);
                    }
                  : undefined // no onClick if entry_type is 2
              }
            >
              <Meta
                title={`Customer: ${
                  selectedOrder.customerName === " "
                    ? "Anonymous Customer"
                    : selectedOrder.customerName
                }`}
                description={
                  selectedOrder.orderList.length !== 0 &&
                  selectedOrder.orderList.map((order, index) => (
                    <Content key={index} className="ps-3 mb-2">
                      <Typography.Text strong>Name: </Typography.Text>
                      <Typography.Text>{order.productName}</Typography.Text>
                      <br />
                      <Typography.Text strong>Description: </Typography.Text>
                      <Typography.Text>{order.productDesc}</Typography.Text>
                      <br />
                      <Typography.Text strong>Qty: </Typography.Text>
                      <Typography.Text>{order.productQty}</Typography.Text>
                    </Content>
                  ))
                }
              />
              {/* <Popconfirm
                title={`Are you sure to void ${selectedOrder.orderNumber}?`}
                onConfirm={(e) => {
                  e?.stopPropagation?.(); // 👈 stop propagation on confirm
                  // console.log("Confirmed void for", selectedOrder.orderNumber);
                  handleVoidOrder(selectedOrder.orderNumber);
                }}
                onCancel={(e) => {
                  e?.stopPropagation?.(); // 👈 stop propagation on confirm
                  console.log("Kinansel na", selectedOrder.orderNumber);
                }}
                onClick={(e) => e.stopPropagation()} // 👈 stop click from bubbling to Card
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="primary"
                  block
                  danger
                  className="mt-3"
                  onClick={(e) => e.stopPropagation()} // 👈 stop Card click
                >
                  VOID
                </Button>
              </Popconfirm> */}
            </Card>
          )}
        </>
      )}
      {selectedOrder.entry_type == 2 && (
        <Button
          type="primary"
          block
          primary
          className="mt-3"
          onClick={() => {
            // setIsOpen(false);
            // navigate(SALES_ORDER_ROUTE);
            // console.log(dataSource);
            setIsSuccessModalOpen(true);
          }}
        >
          Reprint
        </Button>
      )}
      <Button
        type="primary"
        block
        danger
        className="mt-3"
        onClick={() => {
          setIsOpen(false);
          navigate(SALES_ORDER_ROUTE);
        }}
      >
        Close
      </Button>

      <CustomModal
        isLoading={isLoading}
        isOpen={isSuccessModalOpen}
        setIsOpen={setIsSuccessModalOpen}
        cancelText="Close"
        props={{
          okButtonProps: { hidden: true },
          width: modalWidth, // Dynamically set width
        }}
        isClosable={true}
      >
        <ORPrint ORDetails={dataSource} />
        {/* {dataSource.length > 0 && <ORPrint ORDetails={dataSource} />} */}
      </CustomModal>

      {/* For looping on all orders */}
      {/* <Card>
        {localOrderList
          .filter((record) => record.orderList.length === 0)
          .map((record) => (
            <Card.Grid style={gridStyle}>
              <Typography.Title level={3}>
                {record.orderNumber}
              </Typography.Title>
              {record.map((order) => (
                <>
                  <Typography.Text strong>
                    Name: {order.productName}
                  </Typography.Text>
                  <Typography.Text strong>
                    Description: {order.productDesc}
                  </Typography.Text>
                  <Typography.Text strong>
                    Qty: {order.productQty}
                  </Typography.Text>
                </>
              ))}
            </Card.Grid>
          ))}
      </Card> */}
    </Modal>
  );
}
